import cx from 'classnames';

function StepIndicator({ label, isActive, isPartial, isCompleted }) {
  const classes = cx('step-indicator', {
    'is-active': isActive,
    'is-partial': isPartial,
  });
  return (
    <li className={`${classes}`}>
      <span className="step-indicator__icon">
        <span className={cx("step-indicator__line", isCompleted ? 'is-completed' : '')}></span>
      </span>
      {label}
    </li>
  );
}

export default StepIndicator;
